module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAK9JREFUeNpiYBgFwx0wkqtRSlxaH0gJ4FFy4dnLpx9xSbJQ4OgJQOyARfwDEBcALT2ITzMTlUNwARArAC1dSEghC5UsvECML6lpMShYJwAtbCRVI6VBfYEcS2kRx6MWj1o8avGoxaMWozQA/IkRo3oLBGjJfiD1AFTvQoUeQOtgR1LMIbdaTEDjH6BHHBdA62GUpg5dGnvQhh7Mlw7AYL5It1QJshzqgFEwuAFAgAEAAXktZ6+FxcwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/vent/10.png
// module id = 765
// module chunks = 0